import { render, staticRenderFns } from "./DataDiri.vue?vue&type=template&id=a2abc384&"
import script from "./DataDiri.vue?vue&type=script&lang=js&"
export * from "./DataDiri.vue?vue&type=script&lang=js&"
import style0 from "./DataDiri.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports